// lazy loading video 
  document.addEventListener("DOMContentLoaded", function() {
    const lazyVideos = document.querySelectorAll('.cst-product-iframe video');

    if ('IntersectionObserver' in window) {
      let videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            let video = entry.target;
            video.src = video.dataset.src;
            videoObserver.unobserve(video);
          }
        });
      });

      lazyVideos.forEach(video => {
        videoObserver.observe(video);
      });
    } else {
      // Fallback for browsers that don't support IntersectionObserver
      lazyVideos.forEach(video => {
        video.src = video.dataset.src;
      });
    }
  });

// removing # from the navigation
  document.addEventListener("DOMContentLoaded", function () {
  const navLinks = document.querySelectorAll(".site-nav a");

  navLinks.forEach(link => {
    if (link.getAttribute("href") === "#") {
      link.removeAttribute("href");
    }
  });
});


$(document).ready(function(){
  // Initialize Slick Slider
  $('#cst-announcement-slider').slick({
    infinite: true,      // Loop through the slides
    slidesToShow: 1,     // Show 1 slide at a time
    slidesToScroll: 1,   // Scroll 1 slide at a time
    autoplay: true,      // Enable auto-rotation
    autoplaySpeed: 5000, // Set autoplay speed to 5 seconds
    arrows: false,       // Disable previous/next arrows
    dots: false,         // Disable dots
    pauseOnHover: true,   // Pause on hover

     onInit: function() {
      // Remove the display: none style and make the second slider visible
      $('.cst-announcement-slider-child-2').css('display', 'block');
    }
  });
});